import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment.prod';
import { HttpUtilService } from './http-util.service';

export class Task {
  description: string;
  target: any;
  due: string;
}

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  constructor(private http: HttpUtilService) {}
  /**
   * Add a new task for the specified user
   * @param data Information about the task
   * @param item Item task is associated with
   * @param user User thas is assignd to
   */
  createTaskforUser(
    data: Task | any,
    item: string | number,
    user: string | number
  ): Observable<any> {
    return this.http.request(
      'POST',
      environment.apiRoot + '/tasks/user/' + user,
      { data: data, data_id: item },
      null,
      true
    );
  }
  /**
   * Add a new task for the specified role
   * @param data Information about the task
   * @param item Item task is associated with
   * @param role Role the task is assigned to
   */
  createTaskforRole(
    data: Task | any,
    item: string | number,
    role: string
  ): Observable<any> {
    return this.http.request(
      'POST',
      environment.apiRoot + '/tasks/role/' + role,
      { data: data, data_id: item },
      null,
      true
    );
  }
  /**Get list of tasks for the current user */
  getTaskList(): Observable<any> {
    return this.http.request(
      'GET',
      environment.apiRoot + '/tasks/user',
      null,
      null,
      true
    );
  }
  /**
   * Complete a task
   * @param completedTask Task to mark complete
   */
  markComplete(completedTask) {
    return this.http.request(
      'DELETE',
      environment.apiRoot + '/tasks/complete/' + completedTask,
      null,
      null,
      true
    );
  }
}
